import { colors } from 'src/theme/colors'

export const itemTransition = { duration: 0.25, ease: 'easeOut' as const }

// Shared hover variants for article-style cards (CompanyPulseCard, PeopleSpotlightCard).
export const cardHoverVariants = {
  rest: { boxShadow: `0 1px 4px ${colors.gray}` },
  hover: { boxShadow: `0 6px 24px ${colors.gray}, 0 0 0 1px ${colors.gray}` }
} as const

export const cardImageVariants = {
  rest: { scale: 1 },
  hover: { scale: 1.06 }
} as const

export const cardArrowVariants = {
  rest: { opacity: 0, x: 4 },
  hover: { opacity: 1, x: 0, y: 4 }
} as const

export const fadeInUp = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  transition: itemTransition
} as const

export const fadeInLeft = {
  initial: { opacity: 0, x: -20 },
  animate: { opacity: 1, x: 0 },
  transition: itemTransition
} as const
